import { useFeatureValue } from '@growthbook/growthbook-react'
import React, { useState } from 'react'
import { Popconfirm, Popover, Space } from 'antd'
import { Button, ButtonActionBar, DropdownMenu } from 'modules/core/components'
import { useTranslation } from 'react-i18next'
import {
  EditOutlined,
  DeleteOutlined,
  SolutionOutlined,
  CopyOutlined,
  BgColorsOutlined,
} from '@ant-design/icons'
import { ChromePicker } from 'react-color'

const MoreActions = ({
  title,
  loading,
  onConfirmPopconfirm,
  onCancelPopconfirm,
  visible,
  onClickEdit,
  type,
  onClickDuplicate,
  onClickDelete,
  onOpenActivities,
  module = 'forecast',
  color,
  setColor,
  onClickSaveColor,
  onClickCancelSaveColor,
}) => {
  const [openColor, setOpenColor] = useState(false)
  const actionCrudByRole = useFeatureValue('feature-action-crud-role', {
    planning: 'True',
    forecast: 'True',
  })
  const { t } = useTranslation()

  const getDisabledByRole = () => {
    switch (module) {
      case 'planning':
      case 'globalBudget':
        return !(actionCrudByRole.planning === 'True')
      case 'forecast':
      case 'globalForecast':
        return !(actionCrudByRole.forecast === 'True')
      default:
        return false
    }
  }

  return (
    <Popconfirm
      placement="bottomRight"
      title={t('POPCONFIRM_DELETE_DEFAULT_TITLE', { name: title })}
      okText={t('ACTION_DELETE')}
      okButtonProps={{ loading }}
      onConfirm={onConfirmPopconfirm}
      cancelText={t('ACTION_CANCEL')}
      onCancel={onCancelPopconfirm}
      visible={visible}
    >
      <Popover
        trigger="click"
        visible={openColor}
        placement="leftTop"
        onOpenChange={setOpenColor}
        onVisibleChange={(visible) => {
          if (visible) {
            setTimeout(() => {
              const popoverContent = document.querySelector('.ant-popover-inner-content')
              if (popoverContent) {
                popoverContent.style.setProperty('padding', '0px', 'important')
              }
            }, 50)
          }
        }}
        content={
          <div
            onClick={(e) => {
              e.stopPropagation()
            }}
            role="button"
            tabIndex={0}
            style={{ padding: 12 }}
            onTouchStart={(e) => e.stopPropagation()}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.stopPropagation()
              }
            }}
          >
            <Space direction="vertical">
              <ChromePicker
                disableAlpha
                color={color}
                onChangeComplete={(col) => setColor(col.hex)}
              />
              <ButtonActionBar position="space-between">
                <Button.Default
                  title="ACTION_CANCEL"
                  onClick={(e) => {
                    e.stopPropagation()
                    setOpenColor(false)
                    onClickCancelSaveColor(e)
                  }}
                />
                <Button.Primary
                  title="ACTION_SAVE"
                  onClick={(e) => {
                    e.stopPropagation()
                    setOpenColor(false)
                    onClickSaveColor(e)
                  }}
                />
              </ButtonActionBar>
            </Space>
          </div>
        }
      >
        <DropdownMenu
          title={t('ACTION_MORE')}
          onClick={(e) => e.stopPropagation()}
          menu={[
            {
              title: t('ACTION_EDIT_NAME'),
              icon: <EditOutlined />,
              onClick: onClickEdit,
              disabled: getDisabledByRole(),
            },
            {
              title: t('ACTION_CHANGE_COLOR'),
              icon: <BgColorsOutlined />,
              disabled: getDisabledByRole(),
              onClick: (e) => {
                e?.domEvent?.stopPropagation?.()
                e?.stopPropagation?.()

                setTimeout(() => {
                  setOpenColor(true)
                }, 100)
              },
            },
            {
              title: t('ACTION_DUPLICATE'),
              icon: <CopyOutlined />,
              onClick: onClickDuplicate,
              disabled: getDisabledByRole(),
            },
            {
              title: t('ACTION_DELETE'),
              icon: <DeleteOutlined />,
              onClick: onClickDelete,
              disabled: getDisabledByRole(),
            },
            ...(onOpenActivities
              ? [
                  {
                    title: t('ACTION_ACTIVITIES'),
                    icon: <SolutionOutlined />,
                    onClick: onOpenActivities,
                  },
                ]
              : []),
          ]}
        />
      </Popover>
    </Popconfirm>
  )
}

export default MoreActions
